import { DefaultBarChartUiOptions } from './utils/echart';

export const DefaultLineChartProps = {
  type: 'line',
  displayName: 'Line chart',
  uiOptions: DefaultBarChartUiOptions,
} as const;
